import { render, staticRenderFns } from "./relativeFlow.vue?vue&type=template&id=5442600a"
import script from "./relativeFlow.vue?vue&type=script&lang=js"
export * from "./relativeFlow.vue?vue&type=script&lang=js"
import style0 from "./relativeFlow.vue?vue&type=style&index=0&id=5442600a&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\xc\\integrated-business-and-finance-wechat\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5442600a')) {
      api.createRecord('5442600a', component.options)
    } else {
      api.reload('5442600a', component.options)
    }
    module.hot.accept("./relativeFlow.vue?vue&type=template&id=5442600a", function () {
      api.rerender('5442600a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/flow/relativeFlow.vue"
export default component.exports